import { getCountryName } from '@monoimin/utils/formatters';

type Field = string | number;

type FieldRelation = Field | Array<Field>;

export const createPageCountry = <
  T extends FieldRelation | undefined,
  Y = T extends Array<Field> ? Array<string> : string
>(
  country: T
): Y => {
  if (Array.isArray(country) && country.length > 0) {
    return country.map(createPageCountry) as Y;
  }

  if (country && typeof country === 'string') {
    return getCountryName(country, 'en') as Y;
  }

  return '' as Y;
};
